export const projectStartDate = 1588291200000;
